import { Message } from 'element-ui';
import XLSX from 'xlsx';
import { IPSService } from '@/services/ipsServices';

export namespace Functions {
  /**
   * 格式化时间
   * @param {number} timeStamp
   * @return string
   */
  export function timeFormat(timeStamp: number, isShowSeconds = false): string {
    const addZero = (num: number | string): number | string => {
      if (num < 10) {
        num = `0${num}`;
      }
      return num;
    };
    const time = new Date(timeStamp * 1000);
    const year = time.getFullYear();
    const month = addZero(time.getMonth() + 1);
    const date = addZero(time.getDate());
    const hour = addZero(time.getHours());
    const minutes = addZero(time.getMinutes());
    const seconds = addZero(time.getSeconds());
    return isShowSeconds ? `${year}-${month}-${date} ${hour}:${minutes}:${seconds}` : `${year}-${month}-${date} ${hour}:${minutes}`;
  }

  /**
   * 格式化时间(秒)
   * @param {number} timeStamp
   * @return string
   */
  export function timeFormatSec(timeStamp: number, isShowSeconds = false): string {
    const addZero = (num: number | string): number | string => {
      if (num < 10) {
        num = `0${num}`;
      }
      return num;
    };
    const time = new Date(timeStamp * 1000);
    const year = time.getFullYear();
    const month = addZero(time.getMonth() + 1);
    const date = addZero(time.getDate());
    const hour = addZero(time.getHours());
    const minutes = addZero(time.getMinutes());
    const seconds = addZero(time.getSeconds());
    return isShowSeconds ? `${year}/${month}/${date} ${hour}:${minutes}:${seconds}` : `${year}/${month}/${date} ${hour}:${minutes}`;
  }

  /**
   * 格式化数据
   * @param {number} num
   * @return {any} num
   */
  export function numberFormat(num: any): string {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  }

  /**
   * 空数据处理
   * @param {string | number} val
   * @return {any} num
   */
  export function emptyVaribleHandler(val: string): string {
    return val ? val : '/';
  }

  /**
   * 去掉字符串两端的空格和换行符
   * @param {string } val
   * @return {any} num
   */
  export function trim(val: string): string {
    val = val.replace(/(^[\n\r]*)|([\n\r]*$)/g, ''); // 去掉两端的换行符
    val = val.replace(/(^\s*)|(\s*$)/g, ''); // 去掉两端的空格
    return val;
  }

  /**
   * 生成excel
   * @param {any} options
   * @returns null
   */
  export function excelMaker(options: any): void {
    if (options && options.constructor === Object && JSON.stringify(options) !== '{}') {
      if (!(options.columns || options.data)) {
        return;
      }
      let Excel = require('exceljs');
      let saveAs = require('file-saver').saveAs;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('sheet1');
      sheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
      sheet.getRow(1).font = { bold: true };
      sheet.columns = options.columns;
      sheet.addRows(options.data);
      workbook.xlsx.writeBuffer().then((fileData) => {
        let blob = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `${options.name || '新建'}.xlsx`);
        Excel = null;
        saveAs = null;
        workbook = null;
        sheet = null;
        blob = null;
      });
    }
  }

  /**
   * 点击复制内容
   * @param {any} content
   * @param {string} txt
   * @returns null
   */
  export function clickCopy(content: any, txt = ''): void {
    if (!content) {
      return;
    }
    let textArea: any = document.createElement('textArea');
    textArea.value = content;
    textArea.style.opacity = 0;
    document.body.append(textArea);
    textArea.select();
    // select() 方法用于选择该元素中的文本。
    // https://www.w3school.com.cn/jsref/met_textarea_select.asp
    setTimeout(() => {
      document.execCommand('Copy');
      textArea = null;
      Message.success(txt || '拷贝成功');
    }, 100);
  }

  /**
   * 1秒内点击一次
   */
  let isClicked = true;
  let time = null;

  export function limitClick(timeOut) {
    return new Promise((resolve, reject) => {
      if (isClicked) {
        isClicked = false;
        time = setTimeout(() => {
          isClicked = true;
        }, timeOut || 500);
        resolve(true);
      } else {
        reject(false);
      }
    });
  }

  /**
   * 读取excel数据
   */
  export function readExcel(file) {
    return new Promise((resolve, reject) => {
      // 返回Promise对象
      const reader = new FileReader();
      reader.onload = (e) => {
        // 异步执行
        try {
          // 以二进制流方式读取得到整份excel表格对象
          const data = e.target.result,
            workbook = XLSX.read(data, { type: 'binary' });
          const batteryArr = [];
          for (const item in workbook.SheetNames) {
            const SheetName = workbook.SheetNames[item];
            const sheetInfos = workbook.Sheets[SheetName];
            for (const battery in sheetInfos) {
              if (battery != '!ref') {
                batteryArr.push(sheetInfos[battery]);
              }
            }
          }
          resolve(batteryArr);
        } catch (e) {
          reject(e.message);
        }
      };
      reader.readAsBinaryString(file);
    });
  }

  export function readExcelWithNumber(file) {
    return new Promise((resolve, reject) => {
      // 返回Promise对象
      const reader = new FileReader();
      reader.onload = (e) => {
        // 异步执行
        try {
          // 以二进制流方式读取得到整份excel表格对象
          const data = e.target.result,
            workbook = XLSX.read(data, { type: 'binary' });
          const batteryArr = [];
          const arrA = [];
          const arrB = [];
          for (const item in workbook.SheetNames) {
            const SheetName = workbook.SheetNames[item];
            const sheetInfos = workbook.Sheets[SheetName];
            const pattenA = /A/;
            const pattenB = /B/;
            for (const battery in sheetInfos) {
              if (pattenA.test(battery) && battery != '!ref' && battery != '!margins') {
                arrA.push(sheetInfos[battery]);
              }
              if (pattenB.test(battery) && battery != '!ref' && battery != '!margins') {
                arrB.push(sheetInfos[battery]);
              }
              if (battery != '!ref' && battery != '!margins') {
                batteryArr.push(sheetInfos[battery]);
              }
            }
          }
          if (arrA.length === arrB.length) {
            console.log('bingo');
            resolve({ list: batteryArr, deleteNum: 2 });
          } else {
            resolve({ list: arrA, deleteNum: 1 });
          }
        } catch (e) {
          reject(e.message);
        }
      };
      reader.readAsBinaryString(file);
    });
  }

// 装修数据校验2
  export function validateDisplayEditData(displayData: any, type?): { message: string } {
    let message = '';
    let result = false;
    switch (displayData.fieldType) {
      case 'miniPage':
        result = !displayData.desc.pageName || !displayData.desc.pageName.trim();
        if (displayData.desc.buttonInfo.pageInfo.page === 4 && displayData.desc.showButton) {
          !displayData.desc.buttonInfo.pageInfo.pageId && (message = '请选择微页面');
          result = result || !displayData.desc.buttonInfo.pageInfo.pageId;
        }
        break;
      case 'pageVideo':
        result = !displayData.desc.videoUrl || !displayData.desc.videoUrl.trim();
        break;
      case 'picture':
        result = !displayData.desc.pictureUrl || !displayData.desc.pictureUrl.trim();
        break;

      case 'QiKanShowWindow':
        result = !displayData.desc.qiKanName || !displayData.desc.qiKanName.trim();
        result && (message = '期刊橱窗位名称必填');
        break;
      case 'ShowWindowGroup':
        result
          = !displayData.desc.caseGroup
          || !displayData.desc.caseGroup.length
          || !displayData.desc.caseGroup.every(v => !!(v.caseName && v.caseName.trim()));
        result && (message = '橱窗名称必填');
        break;
      case 'Propagate':
        if (type) {
          const isImage = displayData.desc.list.some(val => !val.advPic);
          const isCoupnImg = displayData.desc.list.some(val => val.linkList.some(vls => vls.linkType === 12 && !vls.couponInfo.couponCover));
          const isPoints = displayData.desc.list.some(val => val.linkList.some(vls => vls.linkType === 12 && !vls.couponInfo.points));
          const isRecriptConfig = displayData.desc.list.some(val => !!val?.receiptConfig?.type && !val?.receiptConfig?.id);

          result = isImage || isCoupnImg || isPoints || isRecriptConfig;

          isCoupnImg && (message = '请上传优惠券图片');
          isPoints && (message = '请填写优惠券价格');
          isImage && (message = '请上传图片');
          isRecriptConfig && (message = '请设置顾客参与门槛！');
        }
        break;
      case 'iconMenu':
        const list = displayData.desc.list || [];
        const flag = list.some((v) => {
          // 此处因为商城页也需要图标分类，所以先把||!v.page去掉
          // 标题的验证也去掉
          let r = !v.url;
          if (v.page === 16 || v.page === 3 || v.page === 6) {
            r = r || !v.pageId;
          }
          return r;
        });
        result = flag;
        break;
      case 'HoverIcon':
        if (displayData.desc.list) {
          result = displayData.desc.list.some((v) => {
            return v.page === 16 ? !v.title || !v.title.trim() || !v.pageId : !v.title || !v.title.trim();
          });
        }
        break;
      case 'guide':
        result = !displayData.desc.guideContent || !displayData.desc.guideContent.trim();
        break;
      case 'LabelClass':
        if (displayData.desc.showClassType === 1 && displayData.desc.list && (displayData.desc).list.length) {
          let flag = false;
          flag = displayData.desc.list.some((list) => {
            let r = !list.classPic || !list.className || !list.className.trim();
            if (!list.isAllClass) {
              r = r || !list.relationList || !list.relationList.length;
            }
            // 验证分类导航标签名称是否重复
            const isEqual = displayData.desc.list.some((v, i) => {
              return !!displayData.desc.list.find((d, di) => i !== di && v.className === d.className);
            });
            isEqual && (message = '分类导航名称不能相同');
            !list.classPic && (message = '请上传分类导航图片');
            r = r || isEqual;
            return r;
          });
          result = flag;
        }
        break;
      case 'video':
        result = !displayData.desc.vName || !displayData.desc.vName.trim();
        break;
      case 'backGround':
        result = !displayData.desc.val || !displayData.desc.val.trim();
        break;
      default:
        break;
    }
    return { message };
  }

  /**
   * 装修数据校验
   * type 0 网点组 1 网点
   */
  export function validateDisplayData(displayData: DisplayData[], type?): { index: number; message: string } {
    let message = '';
    let index = -1;
    const caseNameStore: string[] = displayData
      .filter(v => v.fieldType === 'ShowWindow' || v.fieldType === 'ShowWindowGroup')
      .flatMap((val) => {
        return val.fieldType === 'ShowWindow' ? [(val as DisplayShowWindowData).desc.caseName] : (val as DisplayShowWindowGroupData).desc.caseGroup.filter(value => value.caseName && value.caseName.trim()).map(vc => vc.caseName);
      });
    index = displayData.findIndex((data, dx) => {
      let result = false;
      switch (data.fieldType) {
        case 'miniPage':
          result = !(data as MiniPageBg).desc.pageName || !(data as MiniPageBg).desc.pageName.trim();
          if ((data as MiniPageBg).desc.buttonInfo.pageInfo.page === 4 && (data as MiniPageBg).desc.showButton) {
            !(data as MiniPageBg).desc.buttonInfo.pageInfo.pageId && (message = '请选择微页面');
            result = result || !(data as MiniPageBg).desc.buttonInfo.pageInfo.pageId;
          }
          break;
        case 'pageVideo':
          result = !(data as MiniPageVideo).desc.videoUrl || !(data as MiniPageVideo).desc.videoUrl.trim();
          break;
        case 'picture':
          result = !(data as MiniPagePicture).desc.pictureUrl || !(data as MiniPagePicture).desc.pictureUrl.trim();
          break;
        case 'ShowWindow':
          result = !(data as DisplayShowWindowData).desc.caseName || !(data as DisplayShowWindowData).desc.caseName.trim();
          if (!result) {
            if (type) {
              // if((data as DisplayShowWindowData).desc.caseType === 1){
              //   result = !(data as DisplayShowWindowData).desc.classList || !(data as DisplayShowWindowData).desc.classList.length;
              //   message = "请添加分类";
              // }
              // if((data as DisplayShowWindowData).desc.caseType === 3){
              //   result = !(data as DisplayShowWindowData).desc.productCodes || !(data as DisplayShowWindowData).desc.productCodes.trim();
              //   message = "请添加商品";
              // }
            } else {
              const isEqualCaseName = caseNameStore.lastIndexOf((data as DisplayShowWindowData).desc.caseName) != caseNameStore.indexOf((data as DisplayShowWindowData).desc.caseName);
              isEqualCaseName && (message = '商品橱窗位名称不能相同');
              result = isEqualCaseName;
            }
          }
          break;
        case 'QiKanShowWindow':
          result = !(data as DisplayQiKanShowWindowData).desc.qiKanName || !(data as DisplayQiKanShowWindowData).desc.qiKanName.trim();
          if (!result) {
            const isEqualCaseName = caseNameStore.lastIndexOf((data as DisplayQiKanShowWindowData).desc.qiKanName) !== caseNameStore.indexOf((data as DisplayQiKanShowWindowData).desc.qiKanName);
            isEqualCaseName && (message = '期刊橱窗位名称不能相同');
            result = isEqualCaseName;
          }
          break;
        case 'ShowWindowGroup':
          result
            = !(data as DisplayShowWindowGroupData).desc.caseGroup
            || !(data as DisplayShowWindowGroupData).desc.caseGroup.length
            || !(data as DisplayShowWindowGroupData).desc.caseGroup.every(v => !!(v.caseName && v.caseName.trim()))
            || (data as DisplayShowWindowGroupData).desc.caseGroup.some(val => caseNameStore.lastIndexOf(val.caseName) != caseNameStore.indexOf(val.caseName));
          if ((data as DisplayShowWindowGroupData).desc.caseGroup.some(val => caseNameStore.lastIndexOf(val.caseName) != caseNameStore.indexOf(val.caseName))) {
            message = '橱窗名称不能相同';
          }
          break;
        case 'Propagate':
          if (type) {
            const isImage = (data as DisplayPropagateData).desc.list.some(val => !val.advPic);
            const isCoupnImg = (data as DisplayPropagateData).desc.list.some(val => val.linkList.some(vls => vls.linkType === 12 && !vls.couponInfo.couponCover));
            const isPoints = (data as DisplayPropagateData).desc.list.some(val => val.linkList.some(vls => vls.linkType === 12 && !vls.couponInfo.points));
            const isRecriptConfig = (data as DisplayPropagateData).desc.list.some(val => !!val?.receiptConfig?.type && !val.receiptConfig.id);
            result = isImage || isCoupnImg || isPoints || isRecriptConfig;
            isCoupnImg && (message = '请上传优惠券图片');
            isPoints && (message = '请填写优惠券价格');
            isImage && (message = '请上传图片');
            isRecriptConfig && (message = '请设置顾客参与门槛！');
          } else {
            const isEqualProName = displayData.some((v, i) => dx !== i && v.fieldType === 'Propagate' && (v as DisplayPropagateData).desc.pName && (v as DisplayPropagateData).desc.pName === (data as DisplayPropagateData).desc.pName);
            isEqualProName && (message = '广告位名称不能相同');
            result = !(data as DisplayPropagateData).desc.pName || !(data as DisplayPropagateData).desc.pName.trim() || !(data as DisplayPropagateData).desc.pHeight || isEqualProName;
          }
          break;
        case 'iconMenu':
          const list = (data as DisplayIconMenuData).desc.list || [];
          const flag = list.some((v) => {
            // 此处因为商城页也需要图标分类，所以先把||!v.page去掉
            // 标题的验证也去掉
            let r = !v.url;
            if (v.page === 16 || v.page === 3 || v.page === 6) {
              r = r || !v.pageId;
            }
            return r;
          });
          result = flag;
          break;
        case 'HoverIcon':
          if ((data as DisplayHoverIconData).desc.list) {
            result = (data as DisplayHoverIconData).desc.list.some((v) => {
              return v.page === 16 ? !v.title || !v.title.trim() || !v.pageId : !v.title || !v.title.trim();
            });
          }
          break;
        case 'guide':
          result = !(data.desc as GuideDesc).guideContent || !(data.desc as GuideDesc).guideContent.trim();
          break;
        case 'LabelClass':
          if ((data.desc as LabelClassDesc).showClassType === 1 && (data.desc as LabelClassDesc).list && (data.desc as LabelClassDesc).list.length) {
            let flag = false;
            // if(type){
            //   let isList = (data.desc as LabelClassDesc).list.some((list) => !list.classList || !list.classList.length);
            //   let isPic = (data.desc as LabelClassDesc).list.some((list) => !list.classPic);
            //   let isName = (data.desc as LabelClassDesc).list.some((list) => !list.className || !list.className.trim());
            //   isName && (message = "请填写名称");
            //   isPic && (message = "请上传图片");
            //   isList && (message = "请添加分类");
            //   flag = isPic || isName || isList;
            // }else{
            //   flag = (data.desc as LabelClassDesc).list.some((list) => {
            //     let r = !list.classPic || !list.className || !list.className.trim();
            //     if (!list.isAllClass) {
            //       r = r || !list.relationList || !list.relationList.length;
            //     }
            //     // 验证分类导航标签名称是否重复
            //     let isEqual = (data.desc as LabelClassDesc).list.some((v,i) =>{
            //       return !!(data.desc as LabelClassDesc).list.find((d,di) => i !== di && v.className === d.className);
            //     });
            //     isEqual && (message = "分类导航名称不能相同");
            //     !list.classPic && (message = "请上传分类导航图片");
            //     r = r || isEqual;
            //     return r;
            //   });
            // }
            flag = (data.desc as LabelClassDesc).list.some((list) => {
              let r = !list.classPic || !list.className || !list.className.trim();
              if (!list.isAllClass) {
                r = r || !list.relationList || !list.relationList.length;
              }
              // 验证分类导航标签名称是否重复
              const isEqual = (data.desc as LabelClassDesc).list.some((v, i) => {
                return !!(data.desc as LabelClassDesc).list.find((d, di) => i !== di && v.className === d.className);
              });
              isEqual && (message = '分类导航名称不能相同');
              !list.classPic && (message = '请上传分类导航图片');
              r = r || isEqual;
              return r;
            });
            result = flag;
          }
          break;
        case 'Site':
          result = !(data as DisplaySiteData).desc?.siteInfo?.siteLogo;
          result && (message = '请上传店铺LOGO');
          break;
        case 'video':
          result = !(data.desc as VideoDesc).vName || !(data.desc as VideoDesc).vName.trim();
          break;
        case 'backGround':
          result = !(data as DisplayBgData).desc.val || !(data as DisplayBgData).desc.val.trim();
          break;
        default:
          break;
      }
      return result;
    });
    return { index, message };
  }

  // 返回运营模式名称
  export function getOperationModeName(operationMode = 0, isMoreSite = -1): string {
    let result = '';
    switch (Number(operationMode)) {
      case 1:
        result = '镜像店-';
        break;
      case 2:
        result = '云商城-';
        break;
      default:
        result = '未配置';
        break;
    }
    switch (Number(isMoreSite)) {
      case 0:
        result += '单店模式';
        break;
      case 1:
        result += '千店模式';
        break;
      default:
        break;
    }
    return result;
  }

  export function ipsHostUrlApi() {
    const isLocal = window.location.host.includes('localhost');
    const protocol = window.location.protocol;
    const result = `${isLocal ? 'https:' : protocol}//${isLocal ? 'ips.service.qingger.cn' : window.location.host}${isLocal ? '' : '/nips'}`;
    return result;
  }
}
